/*
 * Personalisation fields for made-to-order custom prints.
 *
 * The inputs live outside the product <form> and are associated with it by the
 * form="" attribute, so FormData picks them up on add to cart. The product form
 * is rendered with novalidate, so the required check is done here instead: a
 * capture-phase listener on the document runs before product-form.js sees the
 * submit and stops it if the wording is still empty.
 */
(function () {
  const WRAPPER = '[data-nh-pers]';

  function wrappersForForm(form) {
    if (!form || !form.id) return [];
    return Array.from(document.querySelectorAll(WRAPPER)).filter(
      (wrapper) => wrapper.dataset.formId === form.id
    );
  }

  function updateCount(wrapper) {
    const input = wrapper.querySelector('[data-nh-pers-input]');
    const count = wrapper.querySelector('[data-nh-pers-count]');
    if (!input || !count) return;

    const max = parseInt(wrapper.dataset.max, 10) || 50;
    const used = input.value.length;

    count.textContent = `${used} / ${max}`;
    count.classList.toggle('nh-pers__count--full', used >= max);
  }

  function clearError(wrapper) {
    const error = wrapper.querySelector('[data-nh-pers-error]');
    wrapper.classList.remove('nh-pers--error');
    if (error) error.hidden = true;
  }

  function showError(wrapper) {
    const error = wrapper.querySelector('[data-nh-pers-error]');
    wrapper.classList.add('nh-pers--error');
    if (error) error.hidden = false;
  }

  // Returns true when every required field in this form has been filled in.
  function validate(form) {
    let valid = true;

    wrappersForForm(form).forEach((wrapper) => {
      if (wrapper.dataset.required !== 'true') return;

      const input = wrapper.querySelector('[data-nh-pers-input]');
      if (!input) return;

      if (input.value.trim() === '') {
        showError(wrapper);
        if (valid) {
          wrapper.scrollIntoView({ block: 'center', behavior: 'smooth' });
          input.focus({ preventScroll: true });
        }
        valid = false;
      } else {
        clearError(wrapper);
      }
    });

    return valid;
  }

  function init(root) {
    (root || document).querySelectorAll(WRAPPER).forEach((wrapper) => {
      if (wrapper.dataset.nhPersReady === 'true') return;
      wrapper.dataset.nhPersReady = 'true';

      const input = wrapper.querySelector('[data-nh-pers-input]');
      if (!input) return;

      input.addEventListener('input', () => {
        updateCount(wrapper);
        if (input.value.trim() !== '') clearError(wrapper);
      });

      updateCount(wrapper);
    });
  }

  // Capture phase, so this runs before the bubble-phase listener that
  // product-form.js binds to the form itself.
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (wrappersForForm(form).length === 0) return;

      if (!validate(form)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Theme editor re-renders a section without a page load.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
